// Sentry initialization should be imported first!
import './instrument'

import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import router from './router'
import { useResponsiveStyles } from './hooks'
import '../sensors_config'

import 'keen-slider/keen-slider.min.css'

import { initVConsole } from './utils'

import '@/assets/styles/index.css'
import 'react-provider/dist/style.css'

const container = document.getElementById('root')!
const root = createRoot(container)

initVConsole()

const App = () => {
  useResponsiveStyles()
  return <RouterProvider router={router} />
}

root.render(<App />)
